import { render, staticRenderFns } from "./Avatar.vue?vue&type=template&id=3f40d00e"
import script from "./avatar.ts?vue&type=script&lang=ts&external"
export * from "./avatar.ts?vue&type=script&lang=ts&external"
import style0 from "./avatar.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports